import { Action } from '@ngrx/store';

export enum AuthActionTypes {
    SignInAction = '[Auth] SignIn',
    SignOutAction = '[Auth] SignOut',
    SignUpAction = '[Auth] SignUp',
    ConfirmSignInAction = '[Auth] ConfirmSignInAction',
    ConfirmSignOutAction = '[Auth] ConfirmSignOutAction',
    ChangePasswordAction = '[Auth] ChangePassword',
    ForgotPasswordAction = '[Auth] ForgotPassword',
    CompleteNewPasswordAction = '[Auth] CompleteNewPassword',
    SetupTOTPAction = '[Auth] SetupTOTP'
}

// https://aws-amplify.github.io/docs/js/authentication#sign-in
export class SignIn implements Action {
    readonly type = AuthActionTypes.SignInAction;
    constructor(public payload: { user: any }) {} // TODO: Models
}

// https://aws-amplify.github.io/docs/js/authentication#sign-out
export class SignOut implements Action {
    readonly type = AuthActionTypes.SignOutAction;
}

// https://aws-amplify.github.io/docs/js/authentication#sign-up
export class SignUp implements Action {
    readonly type = AuthActionTypes.SignUpAction;
}

// https://aws-amplify.github.io/docs/js/authentication#change-password
export class ChangePassword implements Action {
    readonly type = AuthActionTypes.ChangePasswordAction;
}


export class ConfirmSignIn implements Action {
    readonly type = AuthActionTypes.ConfirmSignInAction;
}

export class ConfirmSignOut implements Action {
    readonly type = AuthActionTypes.ConfirmSignOutAction;
}

// https://aws-amplify.github.io/docs/js/authentication#forgot-password
export class ForgotPassword implements Action {
    readonly type = AuthActionTypes.ForgotPasswordAction;
}

// https://aws-amplify.github.io/docs/js/authentication#complete-new-password
export class CompleteNewPassword implements Action {
    readonly type = AuthActionTypes.CompleteNewPasswordAction;
}

export class SetupTOTP implements Action {
    readonly type = AuthActionTypes.SetupTOTPAction;
}

export type AuthActions =
    | SignIn
    | SignOut
    | SignUp
    | ConfirmSignIn
    | ConfirmSignOut
    | ChangePassword
    | ForgotPassword
    | CompleteNewPassword
    | SetupTOTP;
